import React from 'react'
import { Link, graphql, StaticQuery } from 'gatsby'

function Navigation({ data }) {
	return (
		<>
			<li className={`home`}>
				<Link to={`/`}>{`Home`}</Link>
			</li>
			{data.allSite.nodes[0].siteMetadata.themeOptions.site.navigation.map(
				node => (
					<li className={`nav-${node.slug}`} key={node.slug}>
						<Link to={node.slug}>{node.label}</Link>
					</li>
				)
			)}
		</>
	)
}

const navigationQuery = graphql`
	{
		allSite {
			nodes {
				siteMetadata {
					themeOptions {
						site {
							navigation {
								label
								slug
							}
						}
					}
				}
			}
		}
	}
`

function StaticNavigation() {
	return (
		<StaticQuery
			query={navigationQuery}
			render={data => <Navigation data={data} />}
		/>
	)
}

export default StaticNavigation
